import { Component, effect, EventEmitter, inject, input, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { selectCreateSuccess } from '../../../../store/selectors/prediction.selectors';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';

import { toSignal } from '@angular/core/rxjs-interop';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-prediction-form',
  imports: [ReactiveFormsModule, CommonModule, ButtonModule, DropdownModule],
  templateUrl: './prediction-form.component.html',
  styleUrl: './prediction-form.component.scss'
})
export class PredictionFormComponent implements OnInit {
  @Output() formSubmit = new EventEmitter<any>();
  @Input() isEditMode: boolean = false;
  initialData = input<any | null>();
  @Input() teams: any[] | undefined = [];
  @Input() competitions: any[] | undefined = [];
  @Input() sports: any[] | undefined = [];
  private store = inject(Store);
  predictionForm!: FormGroup;
  resultOptions: any[] = [
    { label: 'En attente', value: null },
    { label: 'Gagné', value: true },
    { label: 'Perdu', value: false }
  ];
  customErrors = {
    dateError: false,
    isEqualTeams: false
  };



  constructor(private fb: FormBuilder) {
    this.predictionForm = this.fb.group({
      eventName: ['', Validators.required],
      teamHomeName: ['', Validators.required],
      teamAwayName: ['', Validators.required],
      teamHomeConfidence: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      teamAwayConfidence: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      competition: ['', Validators.required],
      sport: ['', Validators.required],
      eventDate: [null, Validators.required],
      analysisText: ['', Validators.required],
      cote: ['', Validators.required],
      result: [null]
    });

    effect(() => {
      const data = this.initialData();
      const formattedDate = data.event_date
      ? new Date(data.event_date).toISOString().slice(0, 16)
      : null;
      
      if (data) {
        this.predictionForm.patchValue({
          eventName: data.event_name,
          teamHomeName: data.team_home ? data.team_home.toString() : '',
          teamAwayName: data.team_away ? data.team_away.toString() : '',
          teamHomeConfidence: data.confidence_team_home ? data.confidence_team_home * 100 : 0,
          teamAwayConfidence: data.confidence_team_away ? data.confidence_team_away * 100 : 0,
          competition: data.competition ? data.competition.toString() : '',
          sport: data.sport ? data.sport.toString() : '',
          eventDate: formattedDate,
          analysisText: data.analysis_text,
          cote: data.cote,
          result: data.result
        });
      }
    });
  }
  ngOnInit(): void {

    this.store.select(selectCreateSuccess).subscribe(success => {
      if (success) {
        this.predictionForm.reset();
      }
    });
  }

  onSubmit(): void {
    if (this.predictionForm.invalid) {
      this.predictionForm.markAllAsTouched();
      return;
    }
    this.formSubmit.emit(this.predictionForm.value);
  }
}
